/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BlockListItem_block$ref: FragmentReference;
export type BlockListItem_block = {|
  +id: string,
  +title: ?string,
  +slug: ?string,
  +active: ?boolean,
  +linkedArticles: ?$ReadOnlyArray<?{|
    +id: string
  |}>,
  +$refType: BlockListItem_block$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "BlockListItem_block",
  "type": "Block",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "slug",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "active",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkedArticles",
      "storageKey": null,
      "args": null,
      "concreteType": "BlockItem",
      "plural": true,
      "selections": [
        v0
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '7de07d4c106c305e32686d15525e1a1e';
module.exports = node;



// WEBPACK FOOTER //
// src/components/blocks/__generated__/BlockListItem_block.graphql.js